import React from 'react';
import { TextField, MenuItem, InputAdornment, Grid } from '@material-ui/core';

import { parseNumber } from '../../utils/parseNumber';
import { useBudget, InstallmentDetails } from './context';
import { paymentOptions } from '../../utils/paymentOptions';
import { NumericFormat } from '../../components/NumericFormat';
import { formatToFloat } from '../../utils/formatCurrency';
import { useSelector } from 'react-redux';

interface InstallmentProps {
    index: number;
    installmentAmount: number;
    installment: InstallmentDetails;
}

export const Installment: React.FC<InstallmentProps> = ({ index, installment, installmentAmount }) => {
    const { user } = useSelector((state: any) => state.auth);

    
    const { classes, installments, dispatchInstallments } = useBudget();

    function handleInstallmentDateChange(date: string) {
        dispatchInstallments({
            type: "CHANGE_DATE",
            payload: {
                index,
                date,
                installment: {
                    ...installment,
                }
            }
        });
    }

    return (
        <div className="row col-lg-12 ml-2 newProductWrapper">
            <Grid item lg={3} md={6} xs={12} className="d-flex align-items-center">
                <div className="mr-2 d-flex justify-content-center align-items-center bg-primary p-2 px-4 mt-2">
                    <label className="text-white m-0">
                        {index + 1}.
                    </label>
                </div>

                <TextField
                    size="small"
                    type="date"
                    label="Data"
                    margin="normal"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={installment.date}
                    onChange={(event) => handleInstallmentDateChange(event.target.value)}
                    disabled={user.isAccountant == "y" ? true : false}
                />
            </Grid>

            <div className="col p-1">
                {index + 1 !== installments.length ? (
                    <NumericFormat
                        key={index}
                        label="Valor"
                        value={installment.value}
                        startAdornment="R$"
                        onChange={
                            ({ target: { value } }) => dispatchInstallments({
                                type: "CHANGE_VALUE",
                                payload: {
                                    index,
                                    value: formatToFloat(value),
                                    amount: installmentAmount,
                                    installment: {
                                        ...installment,
                                        value: formatToFloat(value),
                                    }
                                }
                            })
                        }
                        disabled={user.isAccountant == "y" ? true : false}
                    />
                ) : (
                    <NumericFormat
                        label="Valor"
                        startAdornment="R$"
                        disabled
                        key={index}
                        value={installment.value}
                    />
                )}
            </div>

            <div className="col p-1">
                <TextField
                    select
                    size="small"
                    label="Forma de pgto"
                    SelectProps={{
                        MenuProps: {
                            className: classes.menu,
                        },
                    }}
                    margin="normal"
                    value={installment.installment}
                    onChange={(evt) => dispatchInstallments({
                        type: "CHANGE",
                        payload: {
                            index,
                            installment: {
                                ...installment,
                                installment: evt.target.value
                            }
                        }
                    })}
                    disabled={user.isAccountant == "y" ? true : false}
                >
                    <MenuItem key={-1} value="">
                        Selecione
                    </MenuItem>
                    {
                        paymentOptions.map((payment, i) => {
                            return (
                                <MenuItem key={i} value={payment.value}>
                                    {payment.value}
                                </MenuItem>
                            );
                        })
                    }
                </TextField>

            </div>

            <div className="col p-1">
                <TextField
                    label="Observações"
                    size="small"
                    margin="normal"
                    value={installment.comments}
                    onChange={(evt) => dispatchInstallments({
                        type: "CHANGE",
                        payload: {
                            index,
                            installment: {
                                ...installment,
                                comments: evt.target.value
                            }
                        }
                    })}
                    disabled={user.isAccountant == "y" ? true : false}
                />
            </div>
        </div>
    );
}
